import { Card, Image, Row, Col, Button } from 'antd'
import { CloseCircleOutlined, FileOutlined } from '@ant-design/icons'
import TruncateText from '$components/TruncateText'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const PREVIEWABLE_TYPES = new Set(['image/png', 'image/jpeg', 'image/svg+xml'])

const FileTypeIcon = ({ type = 'JPG' }) => (
  <div style={{ textAlign: 'center' }}>
    <FileOutlined style={{ fontSize: 40 }} />
    <div
      style={{ fontSize: 10, fontWeight: 'bold', textTransform: 'uppercase' }}
    >
      {type}
    </div>
  </div>
)

FileTypeIcon.propTypes = {
  type: PropTypes.string,
}

const BumpmapPreview = ({ imageFile, onRemove }) => {
  const { t } = useTranslation()
  const isPreset = imageFile?.isPreset
  const src = URL.createObjectURL(imageFile.file)
  const name = isPreset ? imageFile.presetName : imageFile.file.name
  const isPreviewable = PREVIEWABLE_TYPES.has(imageFile.file.type)

  return (
    <Card style={{ border: '1px solid #ff6b35' }}>
      <Row gutter={16}>
        <Col>
          {isPreviewable ? (
            <Image
              src={src}
              width={80}
              height={80}
              style={{ borderRadius: 4, objectFit: 'cover' }}
            />
          ) : (
            <FileTypeIcon type={imageFile.file.name?.split('.').pop()} />
          )}
        </Col>
        <Col flex={1}>
          <div
            style={{
              color: '#ff6b35',
              fontSize: 12,
              textTransform: 'uppercase',
            }}
          >
            {isPreset
              ? t('service.apply_texturing.preset')
              : t('service.apply_texturing.uploaded')}
          </div>

          <TruncateText
            text={name}
            style={{ fontSize: 14, maxWidth: '100px', whiteSpace: 'nowrap' }}
          />
        </Col>
        <Col style={{ justifyContent: 'end' }}>
          <Button
            type="text"
            shape="circle"
            icon={<CloseCircleOutlined style={{ fontSize: 20 }} />}
            onClick={onRemove}
          />
        </Col>
      </Row>
    </Card>
  )
}

BumpmapPreview.propTypes = {
  imageFile: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default BumpmapPreview
